'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiLeaf = function TiLeaf(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 18.3c0-8.1-5.8-15.1-13.8-16.6l-0.3-0.1-0.3 0.1c-8.1 1.5-13.9 8.5-13.9 16.6 0 7.7 5.2 14.4 12.5 16.4v2c0 0.9 0.7 1.6 1.7 1.6s1.6-0.7 1.6-1.6v-2c7.4-2 12.5-8.7 12.5-16.4z m-12.5 12.9v-5l7.3-7.3c0.3-0.3 0.3-0.8 0-1.2s-0.9-0.3-1.2 0l-6.1 6.1v-6l4-3.9c0.3-0.3 0.3-0.8 0-1.2s-0.9-0.3-1.2 0l-2.8 2.8v-5.5c0-0.9-0.7-1.7-1.6-1.7s-1.7 0.8-1.7 1.7v5.5l-2.7-2.8c-0.4-0.3-0.9-0.3-1.2 0s-0.3 0.9 0 1.2l3.9 3.9v6l-6.1-6.1c-0.3-0.3-0.8-0.3-1.2 0s-0.3 0.9 0 1.2l7.3 7.3v5c-5.4-1.9-9.2-7-9.2-12.9 0-6.4 4.6-12 10.9-13.3 6.3 1.3 10.8 6.9 10.8 13.3 0 5.9-3.8 11-9.2 12.9z' })
        )
    );
};

exports.default = TiLeaf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/leaf.js
// module id = 2095
// module chunks = 0